import classNames from 'classnames';

export const Search = ({ children, className, ...r }) => {
  const classnames = classNames('search-container flex', className);

  return (
    <div className={classnames} {...r}>
      {children}
    </div>
  );
};